import { inject, provideAppInitializer } from '@angular/core';
import { PrimengDarkModeTogglerService } from './primeng-dark-mode-toggler.service';

export function providePrimengDarkModeToggler() {
  return provideAppInitializer(() => {
    inject(PrimengDarkModeTogglerService);
  });
}
